import React from 'react';
import { useMsal } from '@azure/msal-react';
import { Box } from '@mui/material';
import { UserDropdown } from './UserDropdown';

export const UserInfo: React.FC = () => {
  const { accounts } = useMsal();
  const account = accounts[0];

  if (!account) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <UserDropdown />
    </Box>
  );
};
